import { connect } from 'react-redux'
import CommonPopupComponent from "../components/CommonPopupComponent";
import { loadCommonPopup, setWorkspaceTextFocus, manageToast } from '../actions/index';
const mapStateToProps = (state, ownProps) => ({
    selectedScene       : state.localStore.get('selectedScene'),
    workspaceBG         : state.project.getIn(['scenes',state.localStore.get('selectedScene'),'workspaceBG']),
    commonPopup         : state.localStore.getIn(['commonPopup'])
})
         
  
const mapDispatchToProps = (dispatch, ownProps) => ({
    openCommonPopup     : (value, status)    =>{ 
        dispatch(loadCommonPopup(value, status))
    },
    setWorkspaceTextFocus:(data) => {
        dispatch(setWorkspaceTextFocus(data))
    },
    manageToast: (data) => {
        dispatch(manageToast(data))
    },
    updateUserDetails:(data) => { dispatch({ type: "UPDATE_USER_DETAILS", data}) },
  
})
  
const CommonPopup = connect(mapStateToProps,mapDispatchToProps)(CommonPopupComponent)

export default CommonPopup


// WEBPACK FOOTER //
// ./src/containers/CommonPopup.js